module.exports = __webpack_public_path__ + "static/media/credit-card_amex.12bb1b7f.svg";